import Vue from 'vue'
import Router from 'vue-router'

import We from '@/pages/we/we'
import productDetails from '@/pages/product/productDetails'
import productList from '@/pages/product/productList'
import productArticle from '@/pages/product/productArticle'
import Article from '@/pages/product/article'
import Message from '@/components/Message'
import Order from '@/components/Order'
import Orderdetails from '@/components/Orderdetails'
import ModifyInfo from '@/components/ModifyInfo'
import Receive from '@/components/Receive'
import Service from '@/components/Service'
import ReceiveList from '@/components/ReceiveList'

import productFinish from '@/pages/product/productFinish'
import Payment from '@/pages/payment/payment'
import customized from '@/pages/customized/customized'

import login    from  '@/pages/login/login'
import Register from  '@/pages/login/register'
import forget   from  '@/pages/login/forget'

Vue.use(Router)

const router =  new Router({
	mode: 'history',
	// base: '/hzy/nhuaqi/',
	routes: [
	    {
			path: '/',
			name: 'home',
			component: ()=> import('@/pages/index/index') ,
			meta: {
				title: 'Skatescustom',
				showFooter: true,
				keepAlive: true,
			},
		},
		{
			path: '/productFinish',
			name: 'ProductDetails',
			component: productFinish ,
			meta: {
				title: 'ProductDetails',
				showFooter: true,
				keepAlive: true,
			},
		},
		{
			path: '/productType/:type',
			name: 'productType',
			component: ()=> import('@/pages/product/productType') ,
			meta: {
				title: 'ProductList',
				showFooter: true,
			},
		},
		{
			path: '/about',
			name: 'about',
			component: ()=> import('@/pages/we/about') ,
			meta: {
				title: 'About',
				showFooter: true,
			},
		},
		{
			path: '/productList',
			name: 'ProductList',
			component: productList,
			meta: {
				title: 'ProductList',
				showFooter: true,
			},
		},
		{
			path: '/login',
			name: 'login',
			component: login,
			meta: {
				title: 'Login',
				index: 1,
			},
		},
		{
			path: '/register',
			name: 'register',
			component: Register,
			meta: {
				title: 'Register',
				index: 1,
			},
		},
		{
			path: '/forget',
			name: 'forget',
			component: forget,
			meta: {
				title: 'Forget',
				index: 1,
			},
		},
		{
			path: '/payment',
			name: 'payment',
			component: Payment,
			meta:{
				title:"Payment"
			}
		},
		{
			path: '/product/:id',
			name: 'product',
			component: productDetails,
			meta: {
				index: 2,
				title:"Product"
			},
		},
		
		{
			path: '/productArticle',
			name: 'article',//测量计算文章
			component: productArticle,
			meta: {
				showFooter: true,
				title:"Skatescustom"
			},
		},
		{
			path: '/article',
			name: 'article',
			component: Article,
			meta: {
				showFooter: true,
				title:"Skatescustom"
			},
		},
		{
			path: '/customized/:id',
			name: 'customized',
			component: customized,
			meta: {
				index: 2,
				title:"Skatescustom"

			},
		},
		{
			path: '/help',
			name: 'help',
			component: ()=> import('@/pages/we/help') ,
			redirect: 'help',
			children:[
				{
					path: '/contact',
					name: 'contact',
					meta: {
						index: 2,
						title:"Contact us"

					},
					component: ()=> import('@/components/contact') ,
				},
				{
					path: '/shipping',
					name: 'shipping',
					meta: {
						index: 2,
						title:"Shipping&Delivery"

					},
					component: ()=> import('@/components/shipping') ,
				},
				{
					path: '/returns',
					name: 'returns',
					meta: {
						index: 2,
						title:"Returns"

					},
					component: ()=> import('@/components/returns') ,
					
				}
				
			]
		},
		{
			path: '/we',
			name: 'We',
			component: We,
			redirect: 'message',
			children:[
				{
					path: '/we',
					name: 'message',
					component: Message,
					meta: {
						showFooter: true,
						title:"Message"
					}
				},
				{
					path: '/order',
					name: 'order',
					component: Order,
					meta: {
						showFooter: true,
						title:"Order"
					}
				},

				{
					path:"/orderdetails/:id",
					name:"order",
					component: Orderdetails,
					meta: {
						showFooter: true,
						title:"Order"
					}
				},
				{
					path: '/modifyInfo',
					name: 'modifyInfo',
					component: ModifyInfo,
					meta: {
						showFooter: true,
						title:"userInfo"
					}
				},
				{
					path: '/receive',
					name: 'receive',
					component: Receive,
					meta: {
						showFooter: true,
						title:"Address"
					}
				},
				{
					path: '/receivelist',
					name: 'receive',
					component: ReceiveList,
					meta: {
						showFooter: true,
						title:"Address"
					}
				},
				{
					path: '/service',
					name: 'service',
					component: Service,
					meta: {
						showFooter: true,
						title:"Service"
					}
				}
				
			]
		}
	]
})


router.beforeEach((to, from, next) => {

	document.title = to.meta.title ;
  
    next();

   
});



export default router


// WEBPACK FOOTER //
// ./src/router/index.js